export default invoiceBiduleProofOfResidence

/** @ngInject */
function invoiceBiduleProofOfResidence($uibModal) {
    return ({
        restrict: 'E',
        template: require('./invoiceBiduleProofOfResidence.jade')(),
        link($scope) {
            $scope.openProofOfResModal = () =>
                $uibModal.open({
                    animation: true,
                    size: 'md',
                    controller: 'proofOfResModalCtrl',
                    template: require('../../proofOfResModal/proofofresmodal.jade')(),
                    resolve: {
                        contractId(ApiService, PermPermissionStore) {
                            return __guard__(PermPermissionStore.getStore().client, (x) => x.validatePermission()
                            .then(() =>
                          ApiService.fetchUserInfo()
                          .then((userInfo) => userInfo.contractSelected.id)
                        ))
                        },
                    },
                })
        },
    })
}

function __guard__(value, transform) {
    return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoiceBiduleProofOfResidence.js